import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { PageContainer } from "./PageContainer";
export function TestimonialLogos(param) {
    var items = param.items, _invert = param.invert, invert = _invert === void 0 ? false : _invert, className = param.className;
    return /*#__PURE__*/ _jsx(PageContainer, {
        children: /*#__PURE__*/ _jsx("div", {
            className: clsx("flex flex-col justify-around flex-1 items-center ", "md:flex-row gap-14", className),
            children: items.map(function(x) {
                var LinkOrNot = x.href ? "a" : "div";
                return /*#__PURE__*/ _jsx(LinkOrNot, _object_spread_props(_object_spread({
                    style: _object_spread({
                        opacity: x.opacity
                    }, invert && {
                        filter: "invert()"
                    })
                }, x.href && {
                    href: x.href || "",
                    target: "_blank"
                }), {
                    className: "block appearance-none",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: x.src,
                        alt: "logo",
                        className: "max-w-[180px] max-h-[40px]"
                    })
                }), x.src);
            })
        })
    });
}
